import { doSearchRecipient } from 'actions/recipientSearch/recipientSearch';
import { ScriptStepSubjectDef } from 'xm-constants/scriptStepPermissionDef';

export const FETCH_ROLES = 'FETCH_ROLES';
export const FETCH_ROLES_SUCCESS = `${FETCH_ROLES}_SUCCESS`;
export const FETCH_ROLES_START = `${FETCH_ROLES}_START`;

export const getAllUsersEntity = ({ intl }) => ({
  // This is a placeholder so that the ScriptStepPermissionList can set a key to this entry.
  displayName: intl.formatMessage({ id: 'STEP_PERMISSION_ALL_USERS' }),
  id: '00000000-0000-0000-0000-000000000000',
  recipientType: ScriptStepSubjectDef.allUsers,
  targetName: 'All Users',
});

export function searchRoles(opts) {
  return {
    type: FETCH_ROLES,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/roles`,
      method: 'getall',
      params: {
        search: opts.search,
        limit: 1000,
      },
    },
    payload: opts,
  };
}

/**
 * Action: search for roles/groups/users/ to add them to a permission list.
 * If 'opts.recipientType' isn't supplied, we search for ROLES, PEOPLE, GROUPS (by default)
 * If 'opts.recipientType'===PERSON - we search for ROLES and PEOPLE
 * If 'opts.recipientType'===GROUPS - we search for ROLES and GROUPS
 *
 * If 'opts.excludeAllUsersOption' isn't supplied or false, "All users" option will be displayed in the result (by default)
 * If 'opts.excludeAllUsersOption'===true, "All users" option will be excluded in the result
 * The actual implementation still piggyback on recipient search actions; refactored out here to make things clearer.
 * @param {Object} opts
 */
export const searchForPermissions = opts => dispatch => {
  if (!opts) {
    return Promise.resolve();
  }

  const startIndex = opts.startIndex ? opts.startIndex : 0;
  const recipientType = opts.recipientType
    ? opts.recipientType
    : ['PERSON', 'GROUP'];
  const searchRecipients = doSearchRecipient({
    ...opts,
    permissionSearchMode: !opts?.excludeAllUsersOption,
    recipientType,
  })(dispatch);

  return startIndex === 0
    ? Promise.all([
        dispatch(
          searchRoles({
            search: opts.search,
            permissionSearchMode: !opts?.excludeAllUsersOption,
            intl: opts.intl,
          }),
        ),
        searchRecipients,
      ])
    : searchRecipients;
};
